// extracted by mini-css-extract-plugin
export var bodyText = "twoColumnSlider-module--bodyText--b1c8f";
export var current = "twoColumnSlider-module--current--baadf";
export var grid = "twoColumnSlider-module--grid--d4567";
export var headline = "twoColumnSlider-module--headline--49711";
export var imageContainer = "twoColumnSlider-module--imageContainer--673b0";
export var menu = "twoColumnSlider-module--menu--d5a88";
export var menuButton = "twoColumnSlider-module--menuButton--55063";
export var slideInLeft = "twoColumnSlider-module--slideInLeft--518a9";
export var slideInLeftDesktop = "twoColumnSlider-module--slideInLeftDesktop--e15b4";
export var slideInLeftMobile = "twoColumnSlider-module--slideInLeftMobile--cda26";
export var slideInRight = "twoColumnSlider-module--slideInRight--317db";
export var slideInRightDesktop = "twoColumnSlider-module--slideInRightDesktop--b73d5";
export var slideInRightMobile = "twoColumnSlider-module--slideInRightMobile--69911";
export var slideOutLeft = "twoColumnSlider-module--slideOutLeft--5c12b";
export var slideOutLeftDesktop = "twoColumnSlider-module--slideOutLeftDesktop--e990e";
export var slideOutLeftMobile = "twoColumnSlider-module--slideOutLeftMobile--ecdc3";
export var slideOutRight = "twoColumnSlider-module--slideOutRight--51444";
export var slideOutRightDesktop = "twoColumnSlider-module--slideOutRightDesktop--bca01";
export var slideOutRightMobile = "twoColumnSlider-module--slideOutRightMobile--cf2d0";
export var twoColumnSlider = "twoColumnSlider-module--twoColumnSlider--23c06";
export var twoColumnSliderText = "twoColumnSlider-module--twoColumnSliderText--3614e";